import type { UseFormReturn } from 'react-hook-form';

import { FormField, FormInput } from '@/_components';

import type { InventoryBinLocationFormSchema } from './schemas';

export function FormFields({
  form,
  isEditable = true,
  autoFocus = false,
}: {
  form: UseFormReturn<InventoryBinLocationFormSchema>;
  isEditable?: boolean;
  autoFocus?: boolean;
}) {
  return (
    <>
      <FormField
        control={form.control}
        name="location"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6"
            label="Location (required)"
            {...field}
            disabled={!isEditable}
            autoFocus={autoFocus}
          />
        )}
      />

      {/* <FormField
        control={form.control}
        name="current_stock"
        render={({ field }) => (
          <FormNumberInput
            formItemClassName="col-span-6"
            label="Current Bin Location (required)"
            {...field}
            thousandSeparator
            valueIsNumericString
            fixedDecimalScale
            disabled={!isEditable}
            value={field.value}
            onValueChange={(s) => {
              field.onChange(s.value);
            }}
          />
        )}
      />

      <FormField
        control={form.control}
        name="minimum_stock"
        render={({ field }) => (
          <FormNumberInput
            formItemClassName="col-span-6"
            label="Minimum Bin Location (required)"
            {...field}
            thousandSeparator
            valueIsNumericString
            fixedDecimalScale
            disabled={!isEditable}
            value={field.value}
            onValueChange={(s) => {
              field.onChange(s.value);
            }}
          />
        )}
      />

      <FormField
        control={form.control}
        name="maximum_stock"
        render={({ field }) => (
          <FormNumberInput
            formItemClassName="col-span-6"
            label="Maximum Bin Location (required)"
            {...field}
            thousandSeparator
            valueIsNumericString
            fixedDecimalScale
            disabled={!isEditable}
            value={field.value}
            onValueChange={(s) => {
              field.onChange(s.value);
            }}
          />
        )}
      /> */}
    </>
  );
}
